import { BilingualVideoValue } from '../../../../pages/Redesign/shared/components/VideoImport/bilingual';
import RedesignVideoImport from '../../../../pages/Redesign/shared/components/VideoImport';
import VideoBlock from '../../../../pages/Redesign/shared/components/VideoImport/VideoBlock';
/* eslint-disable import/no-useless-path-segments */
import { Button, IconButton, Typography } from '@material-ui/core';
import { gameBookTemplateActions } from '@orientaction/api-actions';
import TestMainImage from '@orientaction/components/Admin/Test/Create/TestMainInfo/LeftImage/TestMainImage';
import VideoImport, {
  isYoutubeUrl,
  VideoImportValue,
} from '@orientaction/components/Admin/VideoImport';
import MediaVideoPlayer from '@orientaction/components/MediaVideoPlayer';
import { FC, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { ReactComponent as ImportImage } from '../../../../Asset/svg/ImportImage.svg';
import { ReactComponent as ImportVideo } from '../../../../Asset/svg/ImportVideo.svg';
import { ReactComponent as UploadSimple } from '../../../../Asset/svg/UploadSimple.svg';
import ModalEditImg from '../ModalEditImg';
import style from '../ModelPage/style';
import { publicIconPath } from '@orientaction/utils';

interface IEditorImg {
  width: number;
  height: number;
  handleChangeImg?: (infoImg: any) => void;

  defaultUrl?: string;
  isFullHeight?: boolean;
  handleFile?: (file: any) => void;
  keyComponent?: any;
  isVariable?: boolean;
  defaultUrlVideo?: string;
  bilingualVideo?: BilingualVideoValue;
  auto?: number;
  muteVideo?: number;
  handleImageVariable?: (data: any) => void;
  handleVideoVariable?: (data: any) => void;
  indexPageRestitutionNumber?: any;
}

const EditorImg: FC<IEditorImg> = ({
  width,
  height,
  handleChangeImg,
  defaultUrl = null,
  isFullHeight = false,
  handleFile,
  keyComponent,
  isVariable = false,
  defaultUrlVideo = null,
  bilingualVideo,
  auto = 0,
  muteVideo = 0,
  handleImageVariable,
  handleVideoVariable,
  indexPageRestitutionNumber,
}) => {
  const classes = style();
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState('');
  const [position] = useState<any>({});
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [imageDimensions, setImageDimensions] = useState<any>({});

  const handleFileUrlChange = (urlC: string) => {
    setUrl(urlC);
    if (handleChangeImg) {
      handleChangeImg({
        url,
        position,
        file,
      });
    }
    if (urlC) {
      const img = new Image();
      img.src = urlC;

      img.onload = () => {
        setImageDimensions({
          height: img.height,
          width: img.width,
        });
      };
      img.onerror = err => {
        console.error(err);
      };
    }
  };

  const [urlVideo, setUrlVideo] = useState<string>('');
  const [checkedAuto, setCheckedAuto] = useState<boolean>(false);
  const [mute, setMute] = useState<boolean>(false);
  const [videoImportOpen, setVideoImportOpen] = useState(false);
  const localVideoPreviewUrlRef = useRef<string | null>(null);

  const clearLocalVideoPreview = () => {
    if (localVideoPreviewUrlRef.current) {
      URL.revokeObjectURL(localVideoPreviewUrlRef.current);
      localVideoPreviewUrlRef.current = null;
    }
  };

  const handleFileChange = (fileC: any) => {
    setFile(fileC);
    if (handleFile) {
      handleFile(fileC);
    }

    if (handleChangeImg) {
      handleChangeImg({
        url,
        position,
        file,
      });
    }
  };

  const handleDeleteFile = (urlID?: any) => {
    const shouldDeleteUploadedVideo =
      urlVideo && !urlVideo.startsWith('blob:') && !isYoutubeUrl(urlVideo);

    clearLocalVideoPreview();
    setFile(null);
    setUrl('');
    setUrlVideo('');
    setVideoImportOpen(false);
    if (isVariable) {
      if (handleImageVariable && handleVideoVariable) {
        handleImageVariable(null);
        handleVideoVariable({
          video: null,
          videoFile: null,
          videoToDelete: shouldDeleteUploadedVideo ? urlVideo : null,
          autoPlayVideo: null,
          muteVideo: null,
        });
      }
    } else {
      dispatch(gameBookTemplateActions.updateField('illustration', null));
      dispatch(gameBookTemplateActions.updateField('video', null));
      dispatch(gameBookTemplateActions.updateField('videoFile', null));
      dispatch(
        gameBookTemplateActions.updateField(
          'videoToDelete',
          shouldDeleteUploadedVideo ? urlVideo : null
        )
      );
      dispatch(gameBookTemplateActions.updateField('autoPlayVideo', null));
      dispatch(gameBookTemplateActions.updateField('muteVideo', null));
    }
    if (handleChangeImg) {
      handleChangeImg({
        url,
        position,
        file,
      });
    }
  };

  useEffect(() => {
    if (defaultUrl) {
      setUrl(defaultUrl);
    }
  }, [defaultUrl]);

  useEffect(() => {
    if (defaultUrlVideo) {
      if (defaultUrlVideo !== localVideoPreviewUrlRef.current) {
        clearLocalVideoPreview();
      }
      setUrlVideo(defaultUrlVideo);
    }
    setCheckedAuto(auto === 1);
    setMute(muteVideo === 1);
  }, [defaultUrlVideo, auto, muteVideo]);

  useEffect(() => {
    return () => {
      clearLocalVideoPreview();
    };
  }, []);

  useEffect(() => {
    if (imageDimensions.height && imageDimensions.width) {
      setOpen(true);
    }
  }, [imageDimensions]);

  const openImage = () => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setImageDimensions({
        height: img.height,
        width: img.width,
      });
    };
    img.onerror = err => {
      console.error(err);
    };
    setOpen(true);
  };

  const handleVideoSubmit = (value: VideoImportValue) => {
    const shouldDeletePreviousVideo =
      urlVideo &&
      !urlVideo.startsWith('blob:') &&
      !isYoutubeUrl(urlVideo) &&
      urlVideo !== value.video;
    const shouldCreateLocalPreview = !!value.videoFile && value.video.startsWith('blob:');
    const videoUrl = shouldCreateLocalPreview
      ? URL.createObjectURL(value.videoFile as File)
      : value.video;
    clearLocalVideoPreview();
    if (shouldCreateLocalPreview) {
      localVideoPreviewUrlRef.current = videoUrl;
    }

    if (isVariable) {
      if (handleVideoVariable) {
        handleVideoVariable({
          ...value,
          video: videoUrl,
          videoFile: shouldCreateLocalPreview ? value.videoFile || null : null,
          videoToDelete: shouldDeletePreviousVideo ? urlVideo : null,
        });
      }
    } else {
      dispatch(gameBookTemplateActions.updateField('video', videoUrl));
      dispatch(gameBookTemplateActions.updateField('videoFile', value.videoFile || null));
      dispatch(
        gameBookTemplateActions.updateField(
          'videoToDelete',
          shouldDeletePreviousVideo ? urlVideo : null
        )
      );
      dispatch(gameBookTemplateActions.updateField('autoPlayVideo', value.autoPlayVideo));
      dispatch(gameBookTemplateActions.updateField('muteVideo', value.muteVideo));
    }
    setUrlVideo(videoUrl);
    setCheckedAuto(value.autoPlayVideo === 1);
    setMute(value.muteVideo === 1);
    setVideoImportOpen(false);
  };

  const videoValue: BilingualVideoValue = bilingualVideo ? {
    video: bilingualVideo.video || '',
    videoEn: bilingualVideo.videoEn || '',
    autoPlayVideo: bilingualVideo.autoPlayVideo,
    muteVideo: bilingualVideo.muteVideo,
    autoPlayVideoEn: bilingualVideo.autoPlayVideoEn,
    muteVideoEn: bilingualVideo.muteVideoEn,
  } : { video: urlVideo, autoPlayVideo: checkedAuto ? 1 : 0, muteVideo: mute ? 1 : 0 };
  const hasBilingualVideo = !!(videoValue.video || videoValue.videoEn);
  const changeBilingualVideo = (value: BilingualVideoValue) => {
    if (isVariable && handleVideoVariable) handleVideoVariable(value);
    else
      Object.entries(value).forEach(([field, fieldValue]) =>
        dispatch(gameBookTemplateActions.updateField(field, fieldValue))
      );
    setUrlVideo(value.video || '');
  };
  const isEmpty = !url && !urlVideo && !hasBilingualVideo;
  const {
    getRootProps,
    getInputProps,
    open: openImagePicker,
  } = useDropzone({
    accept: 'image/*',
    noClick: true,
    noKeyboard: true,
    onDrop: acceptedFiles => {
      if (!acceptedFiles.length) return;
      const uri = URL.createObjectURL(acceptedFiles[0]);
      handleFileUrlChange(uri);
      handleFileChange(acceptedFiles[0]);
    },
  });

  const renderVideoPlayer = () => {
    return (
      <MediaVideoPlayer
        videoUrl={urlVideo}
        autoPlayVideo={checkedAuto ? 1 : 0}
        muteVideo={mute ? 1 : 0}
        videoClassName={classes.nativeVideo}
      />
    );
  };

  return (
    <div
      key={indexPageRestitutionNumber}
      className={isEmpty ? classes.mediaEmptyContainer : classes.containerMedia}
      style={urlVideo || hasBilingualVideo ? { display: 'block' } : {}}
      {...(isEmpty ? getRootProps() : {})}>
      {isEmpty && <input {...getInputProps()} />}
      {url ? (
        <div key={indexPageRestitutionNumber} className={classes.child}>
          <TestMainImage
            fileUrl={url}
            handleFileUrlChange={handleFileUrlChange}
            handleFileChange={handleFileChange}
            pathPrefix="tests"
            sectionTop={true}
            fullSize={true}
            useForModel={true}
            position={position}
            isFullHeight={isFullHeight}
            useForGame={true}
            keyComponent={keyComponent || Math.random()}
          />
          {url && (
            <div className={classes.iconBtnImage} key={url}>
              <IconButton
                aria-label="delete"
                style={{ background: '#E63C3C', color: '#FFFFFF' }}
                onClick={() => {
                  handleDeleteFile(url);
                }}>
                <img src={`${publicIconPath}/oa_trash_white.svg`} alt="Custom Icon" />
              </IconButton>
              <IconButton
                aria-label="edit"
                style={{ background: '#000A8C', marginTop: 15, color: '#FFFFFF' }}
                onClick={() => openImage()}>
                <img src={`${publicIconPath}/oa_pen_white.svg`} alt="Custom Icon" />
              </IconButton>
            </div>
          )}
          <ModalEditImg
            open={open}
            fileUrl={url}
            width={width}
            height={height}
            imgHeightB={imageDimensions.height as any}
            imgWidthB={imageDimensions.width}
            handleClose={() => setOpen(false)}
            handleUrl={(u: any) => setUrl(u)}
            isVariable={isVariable}
            handleImageVariable={handleImageVariable}
          />
        </div>
      ) : hasBilingualVideo && bilingualVideo ? (
        <VideoBlock value={videoValue} onChange={changeBilingualVideo} />
      ) : urlVideo ? (
        <div>
          {renderVideoPlayer()}
          <div className={classes.iconBtnImage} key={url}>
            <IconButton
              aria-label="delete"
              style={{ background: '#E63C3C', color: '#FFFFFF' }}
              onClick={() => {
                handleDeleteFile(url);
              }}>
              <img src={`${publicIconPath}/oa_trash_white.svg`} alt="Custom Icon" />
            </IconButton>
            <IconButton
              aria-label="edit"
              style={{ background: '#000A8C', marginTop: 15, color: '#FFFFFF' }}
              onClick={() => setVideoImportOpen(true)}>
              <img src={`${publicIconPath}/oa_pen_white.svg`} alt="Custom Icon" />
            </IconButton>
          </div>
        </div>
      ) : (
        <div className={classes.mediaEmptyState}>
          <div className={classes.mediaEmptyIconWrap}>
            <UploadSimple className={classes.mediaEmptyUploadIcon} aria-hidden={true} />
          </div>
          <div className={classes.mediaEmptyTextBlock}>
            <Typography className={classes.mediaEmptyTitle}>
              Ajoutez vos images ou vidéos
            </Typography>
            <Typography className={classes.mediaEmptySubtitle}>
              Glissez-déposez ou sélectionnez depuis votre appareil
            </Typography>
          </div>
          <div className={classes.mediaEmptyActions}>
            <Button
              variant="contained"
              className={classes.mediaImportBtn}
              startIcon={<ImportImage className={classes.mediaImportBtnIcon} aria-hidden={true} />}
              onClick={e => {
                e.stopPropagation();
                openImagePicker();
              }}>
              Importer une image
            </Button>
            <Button
              variant="contained"
              className={classes.mediaImportBtn}
              startIcon={<ImportVideo className={classes.mediaImportBtnIcon} aria-hidden={true} />}
              onClick={e => {
                e.stopPropagation();
                setVideoImportOpen(true);
              }}>
              Importer une vidéo
            </Button>
          </div>
        </div>
      )}
      {bilingualVideo ? (
        <RedesignVideoImport
          bilingual={true}
          open={videoImportOpen}
          onClose={() => setVideoImportOpen(false)}
          onSubmit={changeBilingualVideo}
        />
      ) : (
        <VideoImport
          open={videoImportOpen}
          onClose={() => setVideoImportOpen(false)}
          onSubmit={handleVideoSubmit}
          initialValue={{
            video: urlVideo,
            autoPlayVideo: checkedAuto ? 1 : 0,
            muteVideo: mute ? 1 : 0,
          }}
          deferUpload={!isVariable}
          youtubeInputId="game-video-youtube-url"
        />
      )}
    </div>
  );
};

export default EditorImg;
